module.exports = {
  DOCUMENTS_COLLECTION: 'documents',
  ASSETS_COLLECTION: 'assets',
  METADATA_COLLECTION: 'metadata',
  SNOOTY_REALM_APP_ID: 'snooty-koueq',
};
